import type { EditorProps } from "@monaco-editor/react";
import type { ReactNode } from "react";
import { lazy, Suspense } from "react";

const Editor = lazy(() => import("@monaco-editor/react"));

type LazyMonacoEditorProps = EditorProps & {
  /** Rendered while the Monaco chunk loads. */
  fallback?: ReactNode;
};

/**
 * Shared lazy-loaded Monaco editor. Keeps a single `React.lazy` boundary for
 * `@monaco-editor/react` so the (large) editor chunk is split once and shared
 * by every consumer, each of which supplies its own loading fallback.
 */
export function LazyMonacoEditor({
  fallback = null,
  ...editorProps
}: LazyMonacoEditorProps) {
  return (
    <Suspense fallback={fallback}>
      <Editor {...editorProps} />
    </Suspense>
  );
}
